import React, { useState, useEffect } from "react";
import "./compoLuis.css";
import Hora from "./hora";
import escudoIsep from '../imagenes/escudoIseP.png';
import socket from "../tools/socke";

const CompoLuis = () => {
 
  const [presentesRosario, setPresentesRosario] = useState(0);
  const [presentesRecreo, setPresentesRecreo] = useState(0);
  const [habilitarInputRosario, setHabilitarInputRosario] = useState(false);
  const [habilitarInputRecreo, setHabilitarInputRecreo] = useState(false);
  const [habilitarFooter, setHabilitarFooter] = useState(true); // Nuevo estado para habilitar/deshabilitar el footer
const [cantidadDeRosario, setcantidadDeRosario] = useState();
const [cantidadDeRecreo, setcantidadDeRecreo] = useState();
const [inscriRosario, setinscriRosario] = useState();
const [inscriRecreo, setinscriRecreo] = useState();


  const obi = async () => {
    socket.emit('reempadrone', "2025-2026");

    
  };



  

  useEffect(() => {
    socket.on('actualizoDatosReempadronamiento', (listaObtenidaa) => {

    if(listaObtenidaa.success){
      const info=listaObtenidaa.conteoPorSede
//       console.log(info)
      setcantidadDeRosario(info.Rosario.Convocado);
      setcantidadDeRecreo(info.Recreo.Convocado);
      setinscriRosario(info.Rosario.Propedeutico)
      setinscriRecreo(info.Recreo.Propedeutico)
      }
//      console.log(listaObtenidaa)
     
    });
    // Limpiar socket al desmontar el componente
    return () => {
      socket.off('actualizoDatosReempadronamiento');
    };
  }, []);


  

  const handlePresentesRosarioChange = (event) => {
    setPresentesRosario(event.target.value);
  };

  const handlePresentesRecreoChange = (event) => {
    setPresentesRecreo(event.target.value);
  };

  const toggleInputRosario = () => {
    setHabilitarInputRosario(!habilitarInputRosario);
  };

  const toggleInputRecreo = () => {
    setHabilitarInputRecreo(!habilitarInputRecreo);
  };

  // Función para alternar la visibilidad del footer al hacer clic en la imagen
  const toggleFooter = () => {
    setHabilitarFooter(!habilitarFooter);
    obi()
  };

  return (
    <div className="datos-root">
      <div className="datos-container" style={{display:"flex"}}>
        <div className="datos-cabecera">
          <img 
            className="datos-escudoIsep" 
            src={escudoIsep} 
            alt="ISeP" 
            onClick={toggleFooter} // Al hacer clic en la imagen, alterna la visibilidad del footer
            style={{ cursor: 'pointer' }} // Cambia el cursor a 'pointer' para que se vea como un botón
          />
          <Hora />
          <h2 style={{textAlign:"center"}}> Total convocados <span style={{color:"#999",fontSize:"50px"}}>{cantidadDeRosario+cantidadDeRecreo +inscriRosario+inscriRecreo+ " Postulantes"}</span></h2>
          <h4 style={{textAlign:"center"}}> Reempadronados: <h1 style={{color:"#1ad300",fontSize:"50px"}}>{inscriRosario + inscriRecreo }</h1></h4>
        </div>

        <div className="datos-infoBox">
          <h3>Sede Rosario</h3>
          <p>Convocados: <strong>{cantidadDeRosario}</strong></p>
          <p>Presentes: <strong>{presentesRosario}</strong></p>
          <p>Reempadronados: <strong style={{color: '#1ad300', fontSize: '60px', paddingLeft:'15px'}}>{inscriRosario}</strong> </p>
          <p>Faltan reempadronar: <strong style={{color: '#b01513', fontSize: '60px', paddingLeft:'15px'}}>{cantidadDeRosario }</strong></p>
        </div>

        <div className="datos-infoBox" >
          <h3>Sede Recreo</h3>
          <p >Convocados: <strong>{cantidadDeRecreo}</strong></p>
          <p>Presentes: <strong>{presentesRecreo}</strong></p>
          <p>Reempadronados:  <strong style={{color: '#1ad300', fontSize: '60px', paddingLeft:'15px'}}>{inscriRecreo}</strong>  </p>
          <p>Faltan reempadronar: <strong style={{color: '#b01513', fontSize: '60px', paddingLeft:'15px'}}>{cantidadDeRecreo}</strong></p>
        </div>

        {/* Mostrar u ocultar el footer según el estado habilitarFooter */}
        {habilitarFooter && (
          <div className="datos-footer">
            <div className="datos-inputContainer">
              <input
                type="number"
                value={presentesRosario}
                onChange={handlePresentesRosarioChange}
                min="0"
                max={cantidadDeRosario}
                disabled={!habilitarInputRosario}
                className="datos-inputNumber"
              />
              <button onClick={toggleInputRosario} className="datos-toggleButton">
                {habilitarInputRosario ? "Deshabilitar" : "Habilitar"} Cantidad Rosario
              </button>
            </div>

            <div className="datos-inputContainer">
              <input
                type="number"
                value={presentesRecreo}
                onChange={handlePresentesRecreoChange}
                min="0"
                max={cantidadDeRecreo}
                disabled={!habilitarInputRecreo}
                className="datos-inputNumber"
              />
              <button onClick={toggleInputRecreo} className="datos-toggleButton">
                {habilitarInputRecreo ? "Deshabilitar" : "Habilitar"} Cantidad Recreo
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default CompoLuis;
